import React, { useState, useEffect } from "react";
import "./styles/globals/global.scss";
import "bulma/css/bulma.min.css";
import RegistrationForm from "./components/RegistrationForm";
import CreateYourPageForm from "./components/CreateYourPageForm";
import FinalScreen from "./components/FinalScreen";
import axios from "axios";
import LogosContainer from "./elements/LogosContainer";
import MainLogoContainer from "./elements/MainLogoContainer";

function App() {
  const [stepOne, setStepOne] = useState(true);
  const [stepTwo, setStepTwo] = useState(false);
  const [stepThree, setStepThree] = useState(false);

  const [selectedSite, setSelectedSite] = useState("");
  const [selectSiteFull, setSelectedSiteFull] = useState({});
  const [selectedSiteType, setSelectedSiteType] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");

  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);

  const [campaignTitle, setCampaignTitle] = useState("");
  const [target, setTarget] = useState(100);
  const [customTarget, setCustomTarget] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [btnTxt, setBtnTxt] = useState("REGISTER");
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const [isEmpty, setIsEmpty] = useState(false);
  const [passwordConfirmed, setIsPasswordConfirmed] = useState(false);
  const [isValidEmail] = useState(true);
  const [isValidPassword, setIsValidPassword] = useState(true);

  //const [returnedData, setReturnedData] = useState({});
  const [returnedData, setReturnedData] = useState(null);
  const [returnedError, setReturnedError] = useState("");

  const [charsNumber, setCharsNumber] = useState(false);
  const [lowcase, setLowcase] = useState(false);
  const [uppercase, setUppercase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [specialChar, setSpecialChar] = useState(false);

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const userObj = {
    eventId: "a418fd45-87df-4ad3-b3d2-98beaa9e16aa",
    campaignSetup: {
      targetAmount: 0,
      currencyId: "9d6494c0-e364-43f0-b76c-52251df71133",
      campaignName: "",
      tags: {
        eventDate: "",
        oracle_number: "",
        site_name: "",
        hotel_manager_email_address: "",
        region: "",
        division: ""
      },
    },
    participants: [
      {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        primaryPartcipant: true,
        createAccount: true,
        tags: {
          site: "",
          siteId: "",
        },
      },
    ],
  };

  const [user, setUser] = useState(userObj);

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const finalStep = async (user) => {
    console.log("User:", user);
    const options = {
      method: "POST",
      url: "https://api.givestar.io/api/v1/S2S/Events/Signup",
      headers: {
        "X-GS2SAPI-Key": "rZBSdkg3L06WJs@",
        "X-GS2SAPI-OID": "775d0a8a-1c74-4dcf-b061-06bf90e949f0",
        "Content-Type": "application/json",
      },
      data: user,
    };
    axios(options)
      .then(function (response) {
        if (response.status === 200) {
          setReturnedData(response.data);
        }
      })
      .catch(function (error) {
        setReturnedError(error);
        console.log("Error fetching data:", error);
      });
  };

  const checkPassword = (password) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/g;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const digitRegex = /[0-9]/;

    if (password.length >= 8) {
      setCharsNumber(true);
    } else {
      setCharsNumber(false);
    }

    if (specialCharRegex.test(password)) {
      setSpecialChar(true);
    } else {
      setSpecialChar(false);
    }

    if (lowercaseRegex.test(password)) {
      setLowcase(true);
    } else {
      setLowcase(false);
    }

    if (uppercaseRegex.test(password)) {
      setUppercase(true);
    } else {
      setUppercase(false);
    }

    if (digitRegex.test(password)) {
      setHasNumber(true);
    } else {
      setHasNumber(false);
    }
  };

  useEffect(() => {
    if (
      firstName &&
      lastName &&
      selectedSite &&
      selectedSiteType &&
      email &&
      password &&
      checkbox1 &&
      checkbox2 &&
      isValidPassword
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [
    firstName,
    lastName,
    selectedSite,
    selectedSiteType,
    email,
    password,
    checkbox1,
    checkbox2,
    stepOne,
    isValidPassword
  ]);

  useEffect(() => {
    if (stepTwo) {
      if (campaignTitle && (customTarget || target)) {
        setBtnDisabled(false);
      } else {
        setBtnDisabled(true);
      }
    }
  }, [stepTwo, campaignTitle, customTarget, target]);

  useEffect(() => {
    if (password && isValidPassword) {
      setIsPasswordConfirmed(true);
      setErrorMessage("");
      setIsError(false);
    }
  }, [password, isValidPassword]);

  useEffect(() => {
    if (customTarget !== "") {
      setTarget(0);
    }
  }, [customTarget]);

  useEffect(() => {
    if (charsNumber && lowcase && uppercase && hasNumber && specialChar) {
      setIsValidPassword(true);
    } else {
      setIsValidPassword(false);
    }
  }, [
    isValidPassword,
    charsNumber,
    lowcase,
    uppercase,
    hasNumber,
    specialChar,
  ]);

  const changePage = async () => {
    if (stepOne) {
      if (
        firstName === "" ||
        lastName === "" ||
        email === "" ||
        password === "" ||
        selectedSite === "" ||
        selectedSiteType === ""
      ) {
        setIsEmpty(true);
      } else {
        if (!validateEmail(email)) {
          setIsError(true);
          setErrorMessage("Please enter a valid email address!");
        } else {
          setBtnTxt("CONTINUE");
          setIsError(false);
          setErrorMessage("");
          setIsEmpty(false);

          const updatedUser = {
            ...user,
            participants: user.participants.map((participant) => ({
              ...participant,
              firstName: firstName.trim(),
              lastName: lastName.trim(),
              password: password.trim(),
              email: email.trim(),
              tags: {
                oracle_number: String(selectSiteFull.oracle_number),
                site_name: selectSiteFull.site_name,
                hotel_manager_email_address: selectSiteFull.hotel_manager_email_address,
                region: selectSiteFull.region,
                division: selectSiteFull.division,
              },
            })),
          };

          setUser(updatedUser);
          setStepOne(false);
          setStepTwo(true);
        }
      }
    } else if (stepTwo) {
      if (campaignTitle === "" || (customTarget === "" && target === "")) {
        setIsEmpty(true);
      } else {
        setIsEmpty(false);

        const updatedUser = {
          ...user,
          campaignSetup: {
            ...user.campaignSetup,
            targetAmount: customTarget !== "" ? customTarget : target,
            campaignName: campaignTitle,
            tags: {
              ...user.campaignSetup.tags,
              eventDate: `${year}-${month}-${day}`,
            },
          },
        };

        setUser(updatedUser);
        finalStep(updatedUser);
        setStepTwo(false);
        setStepThree(true);
      }
    }
  };

  return (
    <div
      className="is-flex"
      style={{ height: "100vh", flexDirection: "column" }}
    >
      <div className="topLayerContainer">
        <div className="mobWrapper is-flex">
          {!stepThree && <MainLogoContainer />}
          <div
            className={`${stepThree && "containerThree"} containerWrapper`}
            style={{ position: "relative" }}
          >
            <div
              className={`${!stepThree && "mainContainer"} ${
                stepOne ? "" : "bgMobile"
              } ${stepThree && "finalScreenContainer"}`}
            >
              <div className="mob-container">
                {stepOne && (
                  <div>
                    <RegistrationForm
                      selectedSite={selectedSite}
                      setSelectedSite={setSelectedSite}
                      selectedSiteType={selectedSiteType}
                      setSelectedSiteType={setSelectedSiteType}
                      firstName={firstName}
                      setFirstName={setFirstName}
                      lastName={lastName}
                      setLastName={setLastName}
                      email={email}
                      setEmail={setEmail}
                      isEmpty={isEmpty}
                      checkbox1={checkbox1}
                      checkbox2={checkbox2}
                      setCheckbox1={setCheckbox1}
                      setCheckbox2={setCheckbox2}
                      setPassword={setPassword}
                      specialChar={specialChar}
                      lowcase={lowcase}
                      uppercase={uppercase}
                      hasNumber={hasNumber}
                      charsNumber={charsNumber}
                      checkPassword={checkPassword}
                      setSelectedSiteFull={setSelectedSiteFull}
                    />
                  </div>
                )}
                {stepTwo && (
                  <div>
                    <CreateYourPageForm
                      target={target}
                      setTarget={setTarget}
                      customTarget={customTarget}
                      setCustomTarget={setCustomTarget}
                      isEmpty={isEmpty}
                      campaignTitle={campaignTitle}
                      setCampaignTitle={setCampaignTitle}
                      day={day}
                      month={month}
                      year={year}
                      setDay={setDay}
                      setMonth={setMonth}
                      setYear={setYear}
                    />
                  </div>
                )}
                {stepThree && (
                  <FinalScreen
                    returnedData={returnedData}
                    returnedError={returnedError}
                  />
                )}
              </div>
              {isError && (!passwordConfirmed || isValidEmail) && (
                <div
                  className="notification is-danger is-light"
                  style={{
                    textAlign: "center",
                    width: "100%",
                    padding: "10px",
                    fontSize: "13px",
                  }}
                >
                  {errorMessage}
                </div>
              )}
              {!stepThree && (
                <div className="width100 mobileBtnContainer">
                  <button
                    className="width100 button is-outlined is-uppercase buttonCustom has-text-weight-medium"
                    onClick={() => changePage()}
                    disabled={btnDisabled}
                  >
                    {btnTxt}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <LogosContainer />
    </div>
  );
}

export default App;
